






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class TransactionFeeSlider extends Vue {
  @Prop(String) readonly transactionFeeCurrency!: string;
  @Prop(Number) readonly transactionFeeMin!: number;
  @Prop(Number) readonly transactionFeeMax!: number;
  @Prop(Number) readonly transactionFeeDefault!: number;
  @Prop(Number) readonly transactionFee!: number;
  @Prop(String) readonly transactionType?: string;

  selectedFee = this.transactionFeeDefault;
  pendingUaPreviousSelection: number | undefined = undefined;
  pendingUaNewSelection: number | undefined = undefined;

  get getType() {
    return this.transactionType || 'send';
  }

  get sliderTranslationString() {
    switch (this.transactionType) {
      case 'swap':
        return 'components.wallet.transactionFeeSlider.swappingFee';
      case 'burn':
        return 'components.wallet.transactionFeeSlider.burningFee';
      default:
        return 'components.wallet.transactionFeeSlider.sendingFee';
    }
  }

  get increaseMax() {
    const newIncreasedMax = this.transactionFeeMax * 1.5;
    return newIncreasedMax || this.transactionFeeMax;
  }

  @Watch('selectedFee')
  onSelectedFeeChanged(newValue: number, oldValue: number) {
    this.pendingUaPreviousSelection =
      this.pendingUaPreviousSelection ?? oldValue;
    this.pendingUaNewSelection = newValue;
  }

  onMouseUp() {
    if (
      typeof this.pendingUaNewSelection === 'number' &&
      typeof this.pendingUaPreviousSelection === 'number'
    ) {
      this.$ua.trackTransactionFeeSliderMovedEvent({
        previousSelection: this.pendingUaPreviousSelection,
        newSelection: this.pendingUaNewSelection,
      });
    }

    this.pendingUaPreviousSelection = undefined;
    this.pendingUaNewSelection = undefined;
  }
}
